export const useShowGmailButton = (email: string) => email.endsWith('@gmail.com');
